import React, { Component } from "react";

import logo from "../../assets/images/bleustay-03_small.png";

class Footer extends Component {
  render() {
    return (
      <footer className="f-footer">
        <div className="f-footer-inner">
          <div style={{ textAlign: 'center', paddingBottom: 32, borderBottom: '1px solid rgba(250, 246, 234, 0.12)', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 14 }}>
            <img src={logo} alt="Bleustay" width="56" height="56" loading="lazy" style={{ height: 56, width: 56, objectFit: 'contain', display: 'block' }} />
            <span style={{
              fontFamily: "'Cormorant Garamond', Georgia, serif",
              fontWeight: 500,
              fontSize: '2rem',
              color: 'var(--f-cream)',
              letterSpacing: '-0.005em',
              lineHeight: 1,
            }}>
              Bleustay
            </span>
          </div>

          <div className="f-footer-bottom" style={{ marginTop: 32, paddingTop: 0, borderTop: 0 }}>
            <span>© {new Date().getFullYear()} All rights reserved</span>
            <span>
              Powered by{' '}
              <a
                href="https://develab.io/"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: 'var(--f-clay-soft)', textDecoration: 'none', fontWeight: 600 }}
              >
                Develab
              </a>
            </span>
          </div>
        </div>
      </footer>
    );
  }
}

export default Footer;
